import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";
import hcpReducer from "./slices/hcpSlice";
import callReducer from "./slices/callSlice";

export default combineReducers({
    auth: authReducer,
    hcp: hcpReducer,
    call: callReducer
})